
import MisConsumosTemplate from '@/components/template/mis-consumos-template/mis-consumos-template';
import { graphql, useStaticQuery } from 'gatsby';
import '../../styles/index.scss';

const MisConsumosPersonas = () => {
    const data = useStaticQuery(graphql`
        query GET_PORTAL_SERVICIOS_TRAMITES_USOS {
            allContentfulMetaInfo(
                filter: {
                    titulo: {
                        eq: "Meta información Mis trámites y usos"
                    }
                }
            ) {
                nodes {
                    metaTitulo
                    metaDescripcion
                    metaImagen {
                        file {
                            url
                        }
                    }
                    urlCanonical
                    noIndex
                }
            }
        }
    `);

    return <MisConsumosTemplate data={data} />;
};

export default MisConsumosPersonas;
